import { t } from "i18next";

export const MandatoryField = (label: string, isTranslated?: boolean) => {
  return (
    <span>
      <span style={{ color: "red" }}>*</span>
      {isTranslated ? label : t(label)}
    </span>
  );
};
